/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Col_Subject_RefInputs */

const vi_print_admin_col_subject_ref = /** @type {(inputs: Print_Admin_Col_Subject_RefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng / Lô`)
};

/**

* @param {Print_Admin_Col_Subject_RefInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_col_subject_ref = /** @type {((inputs?: Print_Admin_Col_Subject_RefInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Col_Subject_RefInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_col_subject_ref(inputs)
});